import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { promotedRecordQuery } from './PromotedRecordQuery';

export class PromotedRecordStatusPill extends Field {
  static subqueriesForModel() {
    return {
      promotable: promotedRecordQuery(),
    };
  }

  get title() {
    return 'Promoted to record status name';
  }

  exampleContents(): FieldContentsData {
    return { pill: { text: 'Under consideration', color: '#5793BC' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.promotable?.workflowStatus) {
      return {
        pill: {
          text: record.promotable.workflowStatus.name,
          color: record.promotable.workflowStatus.color,
        },
      };
    }

    return {};
  }
}
